document.addEventListener('click', (e) => {
  const trigger = e.target.closest('.first-level.-has-drop-down')
  if (trigger) {
    e.preventDefault()
    const li = trigger.closest('li')
    const isOpen = li.classList.contains('-open')
    document.querySelectorAll('.hovered-item.-open').forEach(el => el.classList.remove('-open'))
    hideHoverLine()
    if (!isOpen) {
      li.classList.add('-open')
      showHoverLine(trigger)
    }
    return
  }

  if (!e.target.closest('.hovered-item')) {
    document.querySelectorAll('.hovered-item.-open').forEach(el => el.classList.remove('-open'))
    hideHoverLine()
  }
})

$(document)
  .on('click', '.mobile-menu-toggle', function() {
    $('.mobile-header').toggleClass('mobile-header--active')
    $('.header-contained').toggleClass('-expanded')
    
    document.querySelectorAll('.mobile-header__content .back').forEach(button => {
      button.click()
    })

    let activeTab = document.querySelector('.mobile-header__tab.mobile-header__tab--active')
    if(activeTab)
      activeTab.classList.remove('mobile-header__tab--active')
  })

  .on('click', '.mobile-header__tab', function() {
    if(!$(this).hasClass('mobile-header__tab--link')) {
      $(this).addClass('mobile-header__tab--active')
    }

    $(this).siblings().removeClass('mobile-header__tab--active')
    let id = $(this).attr('aria-controls')
    let subMenu = document.getElementById(id)
    if (subMenu) {
      document.querySelector('.mobile-header__tabs-wrapper').classList.add('--hidden')
      subMenu.classList.add('--show')
    }
  })

  .on('click', '.au-search-icon svg', function() {
    $('.nav-overlay').addClass('open')
    $('body').addClass('overflow')
  })

  .on('click', '.au-search-icon .au-close', function() {
    $('.nav-overlay').removeClass('open')
    $('body').removeClass('overflow')
  })

  .on('click', '.nav-overlay', function() {
    $('.nav-overlay').removeClass('open')
    $('body').removeClass('overflow')
  })

  .on('show.bs.dropdown', '.au-search-icon', function() {
    $('.nav-overlay').addClass('open')
    $('body').addClass('overflow')
    $('.search-wrapper').addClass('open')
  })

  .on('hide.bs.dropdown', '.au-search-icon', function() {
    $('.nav-overlay').removeClass('open')
    $('body').removeClass('overflow')
    $('.search-wrapper').removeClass('open')
  })


const hideHoverLine = () => {
  let hover_line = document.querySelector('#hover-line')
  Array.from(document.querySelectorAll('.header-inner ul .first-level')).forEach((elem) => {
    if(elem.parentNode.classList.contains('-active')) {
      if(!elem.parentNode.matches(':hover')){
        elem.parentNode.classList.remove('-active')
        hover_line.classList.remove('-active')
      }
      //if it contains it and not hovering on parentNode's ul element
    }
  })

  Array.from(document.querySelectorAll('.social-part .nav-item')).forEach((elem) => {
    if(elem.parentNode.classList.contains('-active')) {
      elem.parentNode.classList.remove('-active')
      hover_line.classList.remove('-active')
    }
  })
}

const showHoverLine = (elem) => {
  let hover_line = document.querySelector('#hover-line')
  elem.parentNode.classList.add('-active')
  hover_line.classList.add('-active')

  let width = elem.getBoundingClientRect().width
  let left = elem.getBoundingClientRect().left + window.pageXOffset

  hover_line.style.width = `${width}px`
  hover_line.style.left = `${left}px`
}

document.addEventListener('turbo:load', () => {

  Array.from(document.querySelectorAll('.header-inner ul .first-level')).forEach((elem) => {
    elem.addEventListener('mouseenter', () => {
      hideHoverLine()
      showHoverLine(elem)
    })

    elem.addEventListener('mouseleave', () => {
      hideHoverLine()
    })
  })

  Array.from(document.querySelectorAll('.primary-nav-wrapper__nested-parent')).forEach((elem) => {
    elem.addEventListener('mouseleave', () => {
      hideHoverLine()
    })
  })

  Array.from(document.querySelectorAll('.social-part .nav-item')).forEach((elem) => {
    elem.addEventListener('mouseenter', () => {
      hideHoverLine()
      showHoverLine(elem)
    })

    elem.addEventListener('mouseleave', () => {
      hideHoverLine()
    })
  })

  document.querySelectorAll('.mobile-header__content .back').forEach(button => {
    button.addEventListener('click', backButtonHandler)
  })
})

function backButtonHandler() {
  document.querySelectorAll('.mobile-header__content').forEach(submenu => submenu.classList.remove('--show'))
  document.querySelector('.mobile-header__tabs-wrapper').classList.remove('--hidden')
}